import { createSlice } from "@reduxjs/toolkit";

// Sections aligned with jobDetailsSlice initial state keys
const sections = [
  "generalProject",
  "generalStation",
  "soldToShipTo",
  "priceBreakdown",
  "ownersManual",
  "hcRequirements",
  "skidConstruction",
  "pumpManifoldPiping",
  "stationEnclosure",
  "dropPipeComments",
  "dropPipes",
  "levelControls",
  "fillSources",
  "pumps",
  "pumpDetails",
  "waterTreatment",
  "inletScreen",
  "inletStrainer",
  "dischargeStrainer",
  "dischargeFilter",
  "roSystem",
  "uvSystem",
  "fertigation",
  "skyHarvester",
  "shipLoose",
  "unregulatedPower",
  "unregulatedBreakers",
  "regulatedPower",
  "regulatedBreakers",
  "sequenceOfOperations",
  "electricalOptions",
  "telemetry",
  "telemetryAccessories",
  "selectedPumpOptionList",
  "customOptions",
  "warningReport",
  "changedOptions",
  "controlLogicOnly",
  "shipEarlyParent",
  "shipEarlyItems",
];

const defaultBySection = sections.reduce((acc, key) => {
  acc[key] = false; // false = keep legacy per-API fetch enabled (default)
  return acc;
}, {});

const fetchStrategySlice = createSlice({
  name: "fetchStrategy",
  initialState: {
    // Run full-job fetch in parallel with legacy by default
    parallelFullJobEnabled: true,
    // When true for a section, skip legacy fetch and use full-job only
    useFullJobOnlyBySection: defaultBySection,
  },
  reducers: {
    setParallelFullJobEnabled: (state, action) => {
      state.parallelFullJobEnabled = Boolean(action.payload);
    },
    setSectionUseFullJobOnly: (state, action) => {
      const { section, useFullOnly } = action.payload || {};
      if (section in state.useFullJobOnlyBySection) {
        state.useFullJobOnlyBySection[section] = Boolean(useFullOnly);
      }
    },
    setAllSectionsUseFullJobOnly: (state, action) => {
      const value = Boolean(action.payload);
      Object.keys(state.useFullJobOnlyBySection).forEach((k) => {
        state.useFullJobOnlyBySection[k] = value;
      });
    },
  },
});

export const {
  setParallelFullJobEnabled,
  setSectionUseFullJobOnly,
  setAllSectionsUseFullJobOnly,
} = fetchStrategySlice.actions;

export const selectParallelFullJobEnabled = (state) => state.fetchStrategy?.parallelFullJobEnabled;
export const selectUseFullJobOnlyBySection = (state) => state.fetchStrategy?.useFullJobOnlyBySection || {};

export default fetchStrategySlice.reducer;
